<template>
  <app-dropdown data-title="Locais"
                data-menu-width="380px"
                data-menu-padding="10px 20px 20px 20px"
                :data-button-gradient="true">

    <h3 class="text-bold ">Locais</h3>

    <app-search-bar @input="v => load(v)"></app-search-bar>

    <div class="mb-3"></div>

    <app-devices-tree v-model="value"
                      :data-max-height="270"></app-devices-tree>

  </app-dropdown>
</template>

<script>
    import filter from '@mixins/filter'
    import AppDropdown from '@components/Dropdown'
    import AppDevicesTree from '@components/DevicesTree'
    import AppSearchBar from '@components/Search'

    export default {
        components: {
            AppDropdown,
            AppDevicesTree,
            AppSearchBar,
        },

        data() {
            return {
                key: 'devices',
            }
        },

        methods: {
            async load(search) {
                const data = {
                    pagination: {
                        page: 0,
                        amountPerPage: 50,
                    },
                    filters: {
                        orderBy: 'nome',
                        desc: false,
                        active: null,
                        search: search || ''
                    }
                }

                await this.$loader
                    .devices
                    .load(data)
            },
        },

        mixins: [filter],

        mounted() {
            this.search = ''
            this.load()
        },
    }
</script>

<style scoped>
</style>
